import { namespacedClassnames } from '../../common';
import * as React from 'react';
export var labelViewKey = 'label-view';
export var LabelView = function (_a) {
    var label = _a.label, onRemove = _a.onRemove;
    var classNames = namespacedClassnames(labelViewKey, { removable: !!onRemove });
    var localOnRemove = onRemove ? function (e) { return onRemove(label, e); } : undefined;
    return React.createElement("div", { onClick: localOnRemove, className: classNames }, label.name);
};
//# sourceMappingURL=label-view.js.map